module.exports = __webpack_public_path__ + "static/media/img_viewall.a7129174.jpg";